// extracted by mini-css-extract-plugin
export default {"todoList":"TodoList_todoList__PdFfR","warning":"TodoList_warning__CDJHR"};